<template>
  <gkModal v-model="visible" class="modal-login">
    <div class="login-head">
      <h1 class="login-type">{{loginTitle}}</h1>
      <p class="head-sub" v-if="type === 1">未注册的手机号或微信验证后将自动创建新账号，注册即代表同意<a target="_black" rel="noopener nofollow" href="//account.geekbang.org/agreement">《极客邦用户协议》</a></p>
      <!-- <p class="head-sub" v-if="type === 2">已有邮箱账户？<a href="http://" @click.prevent="bindEmail">点此绑定</a></p> -->
    </div>

    <div class="login-form">
      <LoginForm
        :theme="theme"
        :type="type"
        @wechat="thirdLogin"
        @success="loginSuccess"
        @error="loginError"
        @hide="hide"
        @registerSuccess="$emit('registerSuccess')"
      />
    </div>

    <div class="footer" slot="footer">
      <div class="other-login-method">
        其他登录方式
        <i class="iconfont weibo" @click="thirdLogin('weibo')">&#xe63b;</i>
        <i class="iconfont qq" @click="thirdLogin('qq')">&#xe6ac;</i>
      </div>
      <div class="toggle-login" @click="toggleLoginType">
        <template v-if="type === 1">
          账号密码登录
        </template>
        <template v-if="type === 2">
          手机验证码登录
        </template>
      </div>
    </div>
  </gkModal>
</template>

<script>
import state from '../../../store/state'
import VueTypes from 'vue-types'
import gkModal from 'gkuiV2/modal'

import config from '../../../config'
import utils from '../../../utils'

import LoginForm from './LoginForm'
import sensorsReport from '../../../utils/sensors.report'
export default {
  name: 'modal-login',
  components: {
    gkModal,
    LoginForm
  },
  props: {
    theme: VueTypes.oneOf(['blue', 'green']).def('blue')
  },
  data () {
    return {
      onSuccess: null,
      onError: null,
      visible: false,
      type: 1 // 登录类型  1 是手机号登录  2 是账号密码登录
    }
  },
  computed: {
    loginTitle () {
      let domain = state.loginDomain === 'time' ? '极客时间' : ' InfoQ'
      return this.type === 1 ? `登录${domain}` : '密码登录'
    }
  },
  created () {
  },
  methods: {
    show ({success, error}) {
      this.visible = true
      this.onSuccess = success
      this.onError = error
      sensorsReport.pushEvent('dialog_infoq_login', {
        login_type: '快捷登录'
      })
    },
    hide () {
      this.visible = false
      this.onSuccess = null
      this.onError = null
    },
    loginSuccess () {
      this.onSuccess && this.onSuccess().then(() => {
        this.hide()
      }).catch((err) => {
        console.log(err)
      })
    },
    loginError () {
      this.onError && this.onError()
    },
    toggleLoginType () {
      this.type = this.type === 1 ? 2 : 1

      sensorsReport.pushEvent('dialog_infoq_login', {
        login_type: this.type === 1 ? '快捷登录' : '密码登录'
      })
    },
    bindEmail () {
      window.open(`${config.account}/infoq/bind?redirect=${encodeURIComponent(location.href)}`)
    },
    /**
     * 三方登录
     * @params {String} type [wechat, weibo, qq]
     */
    thirdLogin (type) {
      sensorsReport.pushEvent('click_thirdparty', {
        thirdparty_type: type,
        thirdparty_refer: 'InfoQ 弹窗'
      })
      // 三方登陆，携带一些东西
      let params = {}
      let link = location.href
      let redirect = encodeURIComponent(link)
      let gkUcode = utils.getQueryString(link, 'gk_ucode')
      let activity = utils.getQueryString(link, 'activity')
      let gkCusUserWechat = utils.getQueryString(link, 'gk_cus_user_wechat')

      if (gkUcode) {
        params.gk_ucode = gkUcode
      }

      if (activity) {
        params.activity = activity
      }

      params.platform = state.loginDomain

      if (gkCusUserWechat) {
        params.wechat = 'wechat' + gkCusUserWechat
      }
      // params.close_self = 1

      utils.thirdLogin(type, redirect, params)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../assets/css/_common";

.modal-login[gkmodal-color="base"] {
  & ::v-deep [gk-modal-main] {
    box-sizing: border-box;
    width: 442px; min-height: 558px;
    padding: 32px 49px 26px;

    @include mobile () {
      top: 0;
      width: 310px; min-height: auto;
      padding: 34px 24px 23px;
    }
  }
}

.login-head {
  height: 88px;
  margin: 25px 0 15px;

  @include mobile () {
    height: 83px;
    margin: 0;
  }
}

.login-type {
  line-height: 28px;
  @include font(28, 500);
  color: $lightBlack;

  @include mobile () {
    font-size: 20px;
  }
}

.head-sub {
  margin-top: 4px;
  line-height: 21px;
  @include font(14, 400);
  color: $gray;

  & a {
    color: $blue;
  }

  @include mobile () {
    // word-break: keep-all;
    margin-top: 3px; margin-right: -2px;
    line-height: 18px;
    font-size: 12px;
  }
}

.footer {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  height: 20px;
  margin-top: 58px;
  @include font(14, 400);
  color: $gray;

  @include mobile () {
    font-size: 12px;
  }
}

.other-login-method {
  & .iconfont {
    display: inline-block;
    margin-left: 8px;
    font-size: 18px;
    line-height: 18px;
    color: $gray;
    opacity: 0.6;
    cursor: pointer;
    transform: translateY(4px);

    &:hover {
      opacity: 1;
    }

    @include mobile () {
      margin-left: 4px;
    }
  }

  & .weibo {
    font-size: 22px;
    &:hover {
      color: $weiboRed;
    }

    @include mobile () {
      font-size: 18px;
    }
  }

  & .qq {
    font-size: 25px;

    &:hover {
      color: #427FEE;
    }

    @include mobile () {
      font-size: 18px;
    }
  }
}

.toggle-login {
  @extend %transition;
  cursor: pointer;
  user-select: none;

  @include web () {
    &:hover {
      color: $blue;
    }
  }
}
</style>
